// 定义静态路由，动态路由(后端接口返回)及处理在 `utils/routesFilter.js` 中

export default [
    {
        path: '/omo/setting/domain',
        component: () => import('views/modules/setting/domain/index.vue'),
        meta: {
            title: '域名设置',
        },
    },
    {
        path: '/omo/setting/ssl',
        component: () => import('views/modules/setting/ssl/index.vue'),
        meta: {
            title: 'SSL证书',
        },
    },
    {
        path: '/omo/cms/sitestatus',
        component: () => import('views/modules/cms/sitestatus/index.vue'),
        meta: {
            title: '官网状态',
        },
    },
    {
        path: '/omo/cms/website-set/base-set',
        component: () => import('@/views/modules/cms/website-set/base-set/index.vue'),
        meta: {
            title: '基础信息',
        },
    },
    {
        path: '/omo/cms/banner',
        component: () => import('views/modules/cms/banner/index.vue'),
        meta: {
            title: 'Banner管理',
        },
    },
    {
        path: '/omo/cms/navigation',
        component: () => import('views/modules/cms/navigation/index.vue'),
        meta: {
            title: '官网导航',
        },
    },
    {
        path: '/omo/setting/onlineservice',
        component: () => import('views/modules/setting/onlineservice/index.vue'),
        meta: {
            title: '在线客服',
        },
    },
    {
        path: '/omo/static/onlineservice/hotlineSetting',
        component: () => import('views/modules/setting/onlineservice/line-setting.vue'),
        meta: {
            title: '客服热线设置',
        },
    },
    {
        path: '/omo/cms/website-set/virtualroote',
        component: () => import('views/modules/cms/website-set/virtualroot/index.vue'),
        meta: {
            title: '虚拟目录',
        },
    },
    {
        path: '/omo/cms/seo',
        component: () => import('views/modules/cms/seo/index.vue'),
        meta: {
            title: '网站关键词',
        },
    },
    {
        path: '/omo/cms/seo-tool',
        component: () => import('views/modules/cms/seo-tool/index.vue'),
        meta: {
            title: 'SEO工具',
        },
    },
    {
        path: '/omo/static/seo-tool-search-engines',
        component: () => import('views/modules/cms/seo-tool/search-engines/index.vue'),
        meta: {
            title: '搜索引擎设置',
        },
    },
    {
        path: '/omo/static/seo-tool-friendly-link',
        component: () => import('views/modules/cms/seo-tool/friendly-link/index.vue'),
        meta: {
            title: '友情链接',
        },
    },
    {
        path: '/omo/static/seo-tool-website-map',
        component: () => import('views/modules/cms/seo-tool/website-map/index.vue'),
        meta: {
            title: '网站地图',
        },
    },
    {
        path: '/omo/static/seo-tool-robots',
        component: () => import('views/modules/cms/seo-tool/robots/index.vue'),
        meta: {
            title: 'robots',
        },
    },
    {
        path: '/omo/static/seo-tool-dead-links',
        component: () => import('views/modules/cms/seo-tool/dead-links/index.vue'),
        meta: {
            title: '死链',
        },
    },
    {
        path: '/omo/static/seo-tool-redirect',
        component: () => import('views/modules/cms/seo-tool/redirect/index.vue'),
        meta: {
            title: '网址重定向',
        },
    },
    {
        path: '/omo/static/seo-tool-url-rule',
        component: () => import('views/modules/cms/seo-tool/url-rules/index.vue'),
        meta: {
            title: 'URL规则管理',
        },
    },
    {
        path: '/omo/static/sensitive-word-check/detail',
        component: () => import('views/modules/cms/website-set/sensitive-word-check/detail.vue'),
        meta: {
            title: '敏感词过滤',
        },
    },
    {
        path: '/omo/cms/seo-analysis',
        component: () => import('views/modules/cms/seo-analysis/index.vue'),
        meta: {
            title: 'SEO分析',
        },
    },
    {
        path: '/omo/static/seo-analysis/addCompetitor',
        component: () => import('views/modules/cms/seo-analysis/addCompetitor'),
        meta: {
            title: 'seo分析',
        },
    },
    {
        path: '/omo/cms/img-lib',
        component: () => import('views/modules/cms/img-lib/index.vue'),
        meta: {
            title: '图片库',
        },
    },
    {
        path: '/omo/cms/video-lib',
        component: () => import('views/modules/cms/video-lib/index.vue'),
        meta: {
            title: '视频库',
        },
    },
    {
        path: '/omo/cms/file-lib',
        component: () => import('views/modules/cms/file-lib/index.vue'),
        meta: {
            title: '文件库',
        },
    },
    {
        path: '/omo/clues/:appId',
        component: () => import('views/modules/clues/index.vue'),
        meta: {
            title: '线索管理',
        },
    },
    {
        path: '/omo/static/clues/detail',
        name: 'clues-detail',
        component: () => import('views/modules/np/form/app/detail'),
    },
    {
        path: '/omo/static/clues/detail/:appId',
        name: 'clues-detail',
        component: () => import('views/modules/member/clues/detail'),
    },
    {
        path: '/omo/cms/tag-manage',
        component: () => import('views/modules/cms/tag-manage/index.vue'),
        meta: {
            title: '标签管理',
        },
    },
    {
        path: '/omo/cms/website-set/third-party',
        component: () => import('views/modules/cms/website-set/third-party/index.vue'),
        meta: {
            title: '第三方代码',
        },
    },
    {
        path: '/omo/cms/website-set/sensitive-word-check',
        component: () => import('views/modules/cms/website-set/sensitive-word-check/index.vue'),
        meta: {
            title: '敏感词检查',
        },
    },
    {
        path: '/omo/message/sms',
        component: () => import('views/modules/message/sms/index.vue'),
        meta: {
            title: '短信通道',
        },
    },
    {
        path: '/omo/message/email',
        component: () => import('views/modules/message/email/index.vue'),
        meta: {
            title: '邮箱配置',
        },
    },
    {
        path: '/omo/message/stand-msg',
        component: () => import('views/modules/message/stand-msg/index.vue'),
        meta: {
            title: '站内消息',
        },
    },
    {
        path: '/omo/message/set',
        component: () => import('views/modules/message/set/index.vue'),
        meta: {
            title: '提醒设置',
        },
    },
    {
        path: '/omo/cms/nrecyce',
        component: () => import('views/modules/cms/content-recycle/index.vue'),
        meta: {
            title: '提醒设置',
        },
    },
];
